import { useMemo } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { MAP_ROUTE_PATHS } from '@/app/constants';

/**
 * Whether the current URL is a map-view route. Map-scoped URL params (see
 * useAnalysisTypeParamSync for the reference pattern) must gate on this
 * rather than on component mount: route transitions can keep the map tree
 * mounted-but-frozen, so mount state says nothing about the current URL.
 */
export const useIsMapRoute = (): boolean => {
  const { pathname } = useLocation();
  return useMemo(
    () => MAP_ROUTE_PATHS.some((pattern) => matchPath(pattern, pathname)),
    [pathname]
  );
};
